export default __webpack_public_path__ + "static/media/dashboard_icon_gray.ffc875e6.svg";